module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "fm1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmhT"
  }, [_c('b', [_vm._v("Additional Praise for")]), _vm._v(" "), _c('i', [_c('b', [_vm._v("Keep Your Donors: The Guide to Better Communications")])]), _vm._v(" "), _c('b', [_c('i', [_vm._v("and Stronger Relationships")])])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_vm._v("“"), _c('i', [_vm._v("Keep")]), _vm._v(" "), _c('i', [_vm._v("Your Donors")]), _vm._v(" serves as a reminder that what really counts in these donor relationships is the ability to communicate our organization’s vision in such a clear, relevant, compelling and passionate way that they actually look forward to hearing from us. This book offers a practical prescription for many nonprofit ailments, from failure to actively listen to failure to inspire action. It should be on every thoughtful practitioner’s bookshelf.”")]), _vm._v(" "), _c('div', {
    staticClass: "afmtx1"
  }, [_c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("—Sandra A. Adams, Senior Vice President, External Affairs National Breast Cancer Coalition Fund")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_vm._v("“Every single person who considers themselves to be part of building donor relationships must read this book. Truly superb concrete, research based information. You will wish you had it with you all along!”")]), _vm._v(" "), _c('div', {
    staticClass: "afmtx1"
  }, [_c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("—Patricia M Dowling, MSW, Executive Director of The Shoreline Soup Kitchens & Pantries, and past Board President of Interval House.")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_vm._v("“This book isn’t about gimmicks, taste or (what we all secretly fear) manipulating relationships to take advantage of others. Simone and Tom synthesize the body of knowledge and research on fundraising to teach you to communicate so someone can tell if your organization is worthy of his or her interest-and gift. Your relationship with donors is based on their desire to make the world better in some way, and your organization’s ability to accomplish it. They transformed how I write (and I was good before) and made it more comfortable for myself and board members to ask.”")]), _vm._v(" "), _c('div', {
    staticClass: "afmtx1"
  }, [_c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("—Stephen Slaten, Ph.D., Executive Director Jewish Family Service of Worcester, Inc.")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_vm._v("“With inspired precision, energy and passion, Tom and Simone have set a new milestone and raised the bar for fundraisers around the world. "), _c('i', [_vm._v("Keep your Donors")]), _vm._v(" throws down the gauntlet-it is now up to us to share their vision and step outside our comfort zones to meet the challenges of the flat philanthropic world head on!”")]), _vm._v(" "), _c('div', {
    staticClass: "afmtx1"
  }, [_c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("—Jon Duschinsky, Fundraiser France")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx"
  }, [_vm._v("“This book is a “must-have” for those who want to move beyond competence to excellence, beyond formula to strategy, beyond immediate “fix” to long-term stability.”")]), _vm._v(" "), _c('div', {
    staticClass: "afmtx1"
  }, [_c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("—Sarah C. Coviello, CFRE, President Coviello and Associates")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aad4fb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aher_9781118044865_oeb_fm1_r1.vue
// module id = 60
// module chunks = 0